import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import { REPORT_API_URL_LIST }from "../../routes/reports/index.js";
import  store  from '../../../state/store';

async function getInvoiceProfitabilityReport(params, body) {
  let config= {
    headers:{
      Authorization: "Bearer " + store.state.auth.token
    }
  };
  let request = {
    method: "POST",
    url: setParamsToURL(REPORT_API_URL_LIST.INVOICE_PROFITABILITY_URL,params),
    post: body
  }
  return prepareRequest(config,request,true);
}

async function getStockAnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockGroupAnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_GROUP_ANALYSIS_ADD_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockCode1AnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_CODE_1_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockCode2AnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_CODE_2_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockCode3AnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_CODE_3_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockCode4AnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_CODE_4_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getStockCode5AnalysisReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.STOCK_CODE_5_ANALYSIS_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getSalesPersonStockSaleReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.SALES_PERSON_STOCK_SALE_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getBestSalesReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.BEST_SALES_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentPerformanceReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.CURRENT_PERFORMANCE_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getGeneralDebtStatementReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.GENERAL_DEBT_STATEMENT_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getChequeReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.CHEQUE_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getBillReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.BILL_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getSafeReport(params, body) {
    let config= {
      headers:{
        Authorization: "Bearer " + store.state.auth.token
      }
    };
    let request = {
      method: "POST",
      url: setParamsToURL(REPORT_API_URL_LIST.SAFE_URL,params),
      post: body
    }
    return prepareRequest(config,request,true);
}

async function getCurrentGiroReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.CURRENT_GIRO_URL,params),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getSalesPersonGiroReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.SALES_PERSON_GIRO_URL,params),
        post: body
    }
    return prepareRequest(config,request,true);
}

async function getCompanyTotalInfoReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.COMPANY_TOTAL_INFO_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getStockDetailReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.STOCK_DETAIL_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}


async function getMonthGiroDistributionReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.MONTH_GIRO_DISTRIBUTION_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getGiroAnalysisReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.GIRO_ANALYSIS_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getSaleReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.SALE_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getCurrencySaleReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.CURRENCY_SALE_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getPurchaseReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.PURCHASE_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}
async function getCurrencyPurchaseReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.CURRENCY_PURCHASE_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getChequeSumReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.CHEQUE_SUM_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getBillSumReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.BILL_SUM_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getBorrowerCurrentListReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.BORROWER_CURRENT_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getTop10CurrentListReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.TOP_10_CURRENT_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getPayeeCurrentListReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.PAYEE_CURRENT_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getBestStockListReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.BEST_STOCK_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getSalespersonSalePaymentReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.SALESPERSON_SALE_PAYMENT_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getExpenseReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.EXPENSE_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getExpenseTotalReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.EXPENSE_LIST_TOTAL_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getSalespersonSalePaymentDetailReport(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.SALESPERSON_SALE_PAYMENT_DETAIL_LIST_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getBanks({params, body}) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.BANKS_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getBankDetails(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(REPORT_API_URL_LIST.BANK_DETAILS_URL,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getCurrentAgingSummarySum(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.CURRENT_AGING_SUMMARY_SUM,params),
        post: body
    }
    return prepareRequest(config,request,false);
}

async function getCurrentVisitReport(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.CURRENT_VISIT, params),
        post: body
    }
    return prepareRequest(config, request, false);
}

async function getNewCurrentReport(params, body) {
    let config = {
        headers: {
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(REPORT_API_URL_LIST.NEW_CURRENT, params),
        post: body
    }
    return prepareRequest(config, request, false);

}

export {

    getInvoiceProfitabilityReport,
    getStockAnalysisReport,
    getStockGroupAnalysisReport,
    getStockCode1AnalysisReport,
    getStockCode2AnalysisReport,
    getStockCode3AnalysisReport,
    getStockCode4AnalysisReport,
    getStockCode5AnalysisReport,
    getSalesPersonStockSaleReport,
    getBestSalesReport,
    getCurrentPerformanceReport,
    getGeneralDebtStatementReport,
    getChequeReport,
    getBillReport,
    getSafeReport,
    getCurrentGiroReport,
    getSalesPersonGiroReport,
    getCompanyTotalInfoReport,
    getStockDetailReport,
    getMonthGiroDistributionReport,
    getGiroAnalysisReport,
    getSaleReport,
    getCurrencySaleReport,
    getPurchaseReport,
    getCurrencyPurchaseReport,
    getChequeSumReport,
    getBorrowerCurrentListReport,
    getPayeeCurrentListReport,
    getBestStockListReport,
    getSalespersonSalePaymentReport,
    getExpenseReport,
    getExpenseTotalReport,
    getSalespersonSalePaymentDetailReport,
    getTop10CurrentListReport,
    getBillSumReport,
    getBanks,
    getBankDetails,
    getCurrentAgingSummarySum,
    getCurrentVisitReport,
    getNewCurrentReport,
};